// extracted by mini-css-extract-plugin
export default {"title":"_1eacf2a508","inner_title":"_7e6a7906dd","charge_btn":"_8a7865d7c0"};